import { Fragment, useEffect } from 'react';
import {
  useEditorStore,
  useFlowBuilder2Store,
  useInvalidateEditorModel,
  useInvalidateEditorContent,
} from '@diana/core';

export const InvalidateLayoutsModelAndContent = () => {
  const getLayouts = useEditorStore((s) => s.getLayouts);
  const isSaving = useFlowBuilder2Store((s) => s.requests.some((r) => !r.error));
  const invalidateEditorModel = useInvalidateEditorModel();
  const invalidateEditorContent = useInvalidateEditorContent();

  useEffect(() => {
    if (isSaving) {
      return () => {
        const layouts = Object.values(getLayouts());
        for (const layout of layouts) {
          invalidateEditorModel(layout.id);
          invalidateEditorContent(layout.id);
          if (Array.isArray(layout.components)) {
            for (const component of layout.components) {
              invalidateEditorModel(component.id);
              invalidateEditorContent(component.id);
            }
          }
        }
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSaving]);

  return <Fragment />;
};
